import { IconButtonMenuProps, IconButtonMenu } from './IconButtonMenu';
import { MoreHoriz as EllipsesIcon } from '@mui/icons-material';

const EllipsesMenu = (props: Omit<IconButtonMenuProps, 'icon'>) => (
  <IconButtonMenu {...props} icon={<EllipsesIcon />} />
);

export default EllipsesMenu;
